import * as React from "react";

import { cn } from "@/lib/utils";

interface InputProps extends React.ComponentProps<"input"> {
  /** Clear the input value when focused if it's zero (for number inputs) */
  clearZeroOnFocus?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, clearZeroOnFocus, onFocus, ...props }, ref) => {
    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      // For number inputs, clear the value if it's 0 and select all
      if (type === "number") {
        const value = e.target.value;
        const numValue = parseFloat(value);
        
        // Check if value is zero (0, 0.00, 0,00, etc.)
        if (numValue === 0 || value === "0" || value === "0.00" || value === "0,00") {
          // Clear the value
          e.target.value = "";
        } else {
          // Select all text for easier editing
          e.target.select();
        }
      }
      
      // Call the original onFocus if provided
      onFocus?.(e);
    };

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        onFocus={handleFocus}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
